export enum EHostKey {
  TadAi = 'tad.ai',
  VocalremoverInfo = 'vocalremover.info',
}

/**
 * 会被 fallback 处理的虚拟 hostKey
 *
 * fallback 关系在 fallbackHostKeyMap 维护
 */
export enum EVirtualHostKey {
  TadFallbackAi = 'tad-fallback.ai',
}

export type TSupportedHostKey = EHostKey | EVirtualHostKey

export const HOST_PREFIX = '(dev.|test123.|)'
/** Cloudflare 二级子域名需要氪金，因此内部仅支持一级子域名即可 */
export const SUB_HOST_PREFIX = '(dev-|test123-|)'
